export const AI_ACTION_TYPES = {
  CREATE_AI_HEADER_SECTION_LOADED: "CREATE_AI_HEADER_SECTION_LOADED",
  CREATE_AT_BODY_SECTION_LOADED: "CREATE_AI_BODY_SECTION_LOADED",
  CREATE_AT_FOOTER_SECTION_LOADED: "CREATE_AI_FOOTER_SECTION_LOADED",
  GET_HEADER_DATA_FOR_PARTICULAR: "GET_HEADER_DATA_FOR_PARTICULAR",
  GET_BODY_DATA_FOR_PARTICULAR: "GET_BODY_DATA_FOR_PARTICULAR",
  GET_FOOTER_DATA_FOR_PARTICULAR: "GET_FOOTER_DATA_FOR_PARTICULAR",
  UPDATE_AI_HEADER_DATA_SECTION: "UPDATE_AI_HEADER_DATA_SECTION",
  UPDATE_AI_BODY_DATA_SECTION: "UPDATE_AI_BODY_DATA_SECTION",
  UPDATE_AI_FOOTER_DATA_SECTION: "UPDATE_AI_FOOTER_DATA_SECTION",
  SET_HEADER_DATA_NULL: "SET_HEADER_DATA_NULL",
  SET_BODY_DATA_NULL: "SET_BODY_DATA_NULL",
  SET_FOOTER_DATA_NULL: "SET_FOOTER_DATA_NULL",
  DELETE_AI_DATA: "DELETE_AI_DATA",
  GET_AI_AGENT_ID: "GET_AI_AGENT_ID",
  GET_AI_DATA_BY_AGENT_ID: "GET_AI_DATA_BY_AGENT_ID",
  SET_AI_DATA_NULL: "SET_AI_DATA_NULL",
  GET_ALL_AI_DATA: "GET_ALL_AI_DATA",
  GET_ALL_AGENT_DETAILS: "GET_ALL_AGENT_DETAILS",
  GET_CREATED_AGENT_RESPONSE: "GET_CREATED_AGENT_RESPONSE",
  ASSIGN_CAMPAIGN: "ASSIGN_CAMPAIGN",
  GET_UNASSIGNED_CAMPAIGNS: "GET_UNASSIGNED_CAMPAIGNS",
  UPDATE_ASSIGNED_CAMPAIGN_IN_VMS:"UPDATE_ASSIGNED_CAMPAIGN_IN_VMS",
  GET_ASSIGNED_CAMPAIGNS: "GET_ASSIGNED_CAMPAIGNS",
  UPDATE_AI_ASSIGNED_CAMPAIGN_BY_ID:"UPDATE_AI_ASSIGNED_CAMPAIGN_BY_ID",
  DELETE_AGENT_AI: "DELETE_AGENT_AI",
  UPDATE_AI_AGENT: "UPDATE_AI_AGENT",
  GET_AI_AGENT_DATA_BY_ID: "GET_AI_AGENT_DATA_BY_ID",
  CHECK_DATA_STRUCTURE_BY_AI_ID: "CHECK_DATA_STRUCTURE_BY_AI_ID",
  ONGOING_AGENTID: "ONGOING_AGENTID",
};
